export const initState = {
	render: 'sendOtp',

	sendOtp: {
		_send: 'init',
		$send: null,

		phone: '',
	},
	checkOtp: {
		_check: 'init',
		$check: null,

		otp: '',
	},
};

export default initState;
